export default function messaging(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_MESSAGE':
      return { ...state, ...action.payload }
    case 'CLEAR_MESSAGE':
      return {}
    default:
      return state
  }
}
